import React from 'react'
import styled, { css } from 'styled-components'

import { applyTextStyle } from '../../styles/typography'
import { fastTransition } from '../../styles/effects'

interface IProps {
  clearLabel: string
  applyLabel: string
  onClear: () => void
  onApply: () => void
  applyDisabled?: boolean
  clearDisabled?: boolean
  applyHighlighted?: boolean
}

const FilterFooter: React.FC<IProps> = ({
  clearLabel,
  applyLabel,
  onClear,
  onApply,
  applyDisabled,
  clearDisabled,
  applyHighlighted,
}) => (
  <Wrapper>
    <FooterButton type="button" onClick={onClear} disabled={clearDisabled}>
      {clearLabel}
    </FooterButton>
    <FooterButton
      type="button"
      onClick={onApply}
      disabled={applyDisabled}
      highlighted={applyHighlighted}
      primary
    >
      {applyLabel}
    </FooterButton>
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  border-top: 1px solid ${({ theme }) => theme.colors.primaryLight};
`

const FooterButton = styled.button<{
  primary?: boolean
  highlighted?: boolean
}>`
  flex: 1;
  padding: 14px 16px;
  border: 0;
  background: transparent;
  cursor: pointer;
  ${applyTextStyle('labelSmallCaps')}
  color: ${({ theme }) => theme.colors.text72};
  transition: background-color ${fastTransition}, color ${fastTransition};

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.primaryLight};
  }

  &:disabled {
    cursor: default;
    color: ${({ theme }) => theme.colors.textLighter};
    background-color: transparent;
  }

  ${({ primary, theme }) =>
    primary &&
    css`
      color: ${theme.colors.primary};
    `}

  ${({ highlighted, theme }) =>
    highlighted &&
    css`
      color: ${theme.colors.lightest};
      background-color: ${theme.colors.primary};

      &:hover {
        color: ${theme.colors.lightest};
        background-color: ${theme.colors.primary};
      }
    `}
`

export default FilterFooter
